/*=========================================================================================
  File Name: moduleCompanyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	// Consulta las configuraciones de compañia
	fetchDataListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/config/company")
				.then((res) => {
					commit("SET_COMPANIES", res.data ? res.data : []);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// Consulta las configuraciones de compañia
	fetchConfigCompanyById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/config/company/0/${id}`)
				.then((res) => {
					commit("SET_COMPANIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// Elimina item
	removeItemConfigCompany({commit}, {config_id, company_id}) {
		return new Promise((resolve, reject) => {
			Api.delete(`/config/company/${config_id}/${company_id || ""}`)
				.then((response) => {
					commit("REMOVE_COMPANY", config_id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Consulta una configuración especifica
	getListConfig({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/type/config")
				.then((res) => {
					commit("SET_CONFIG_LIST", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	// Consulta una configuración es especifico
	getOnlyConfig({commit}, type_config_id) {
		return new Promise((resolve, reject) => {
			Api.get(`/type/config/${type_config_id}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea configuración
	addCompanyConfig({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/config/company", object)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza configuración
	updateCompanyConfig({commit}, item) {
		let id = item.id;
		delete item["id"];
		return new Promise((resolve, reject) => {
			Api.put(`/config/company/${id}`, item)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
